const useFullScreenElement = () => ({
  element: document.fullscreenElement ? (document.fullscreenElement as HTMLElement) : undefined,
});

export { useFullScreenElement };
